export type Priority = 1 | 2 | 3
export type ColumnColor = 'gray' | 'blue' | 'steel' | 'green'

export interface User {
  id: number
  email: string
  displayName: string
}

export interface Column {
  id: number
  name: string
  position: number
  color: ColumnColor
}

export interface Task {
  id: number
  /** Presentational alias of id, e.g. "T-102". */
  ref: string
  title: string
  descriptionMd: string
  columnId: number
  position: number
  assigneeId: number | null
  priority: Priority
  dueDate: string | null
  labels: string[]
  createdBy: number
  /** Zadanie założone przez agenta przez /mcp — karta pokazuje chip (ui-spec §5.2). */
  createdByAgent: boolean
  createdAt: string
  updatedAt: string
  archivedAt: string | null
  /** Rendered only when > 0 (ui-spec §5.2). */
  commentCount: number
}

export const PRIORITY_LABEL: Record<Priority, string> = {
  1: 'wysoki',
  2: 'normalny',
  3: 'niski',
}
